// extracted by mini-css-extract-plugin
module.exports = {"table":"StrategiesTableView_table__2ofcq"};